<h2 mat-dialog-title class="dialog-admin-upsert__title">{{ data.title }}</h2>

<mat-dialog-content class="dialog-admin-upsert__content">
  @if (data.message) {
    <p class="dialog-admin-upsert__message">{{ data.message }}</p>
  }

  <form
    id="adminUpsertForm"
    class="dialog-admin-upsert__form"
    [formGroup]="form"
    (ngSubmit)="submit()"
  >
    <!-- First Name -->
    <div class="dialog-admin-upsert__field">
      <ui-molecule-input
        textId="firstName"
        formControlName="firstName"
        [label]="'users.upsert.firstName.label' | translate"
        [placeholder]="'users.upsert.firstName.placeholder' | translate"
        [required]="true"
        [maxLength]="firstNameMax"
        [errorMessage]="firstNameError"
      />
    </div>

    <!-- Last Name -->
    <div class="dialog-admin-upsert__field">
      <ui-molecule-input
        textId="lastName"
        formControlName="lastName"
        [label]="'users.upsert.lastName.label' | translate"
        [placeholder]="'users.upsert.lastName.placeholder' | translate"
        [required]="true"
        [maxLength]="lastNameMax"
        [errorMessage]="lastNameError"
      />
    </div>

    <!-- Email -->
    <div class="dialog-admin-upsert__field">
      <ui-molecule-input
        textId="email"
        formControlName="email"
        [label]="'users.upsert.email.label' | translate"
        [placeholder]="'users.upsert.email.placeholder' | translate"
        type="email"
        [required]="true"
        [maxLength]="emailMax"
        [errorMessage]="emailError"
      />
    </div>

    <!-- Role -->
    @if (showRoleSelector) {
      <div class="dialog-admin-upsert__field">
        <label class="dialog-admin-upsert__label">Role</label>
        <mat-select formControlName="role" class="dialog-admin-upsert__select">
          @for (role of data.availableRoles; track role) {
            <mat-option [value]="role">
              {{ getRoleDisplayName(role) }}
            </mat-option>
          }
        </mat-select>
      </div>
    }

    <!-- Password -->
    @if (data.mode !== 'edit') {
      <div class="dialog-admin-upsert__field">
        <ui-molecule-input
          textId="password"
          formControlName="password"
          [label]="'users.upsert.password.label' | translate"
          [placeholder]="'users.upsert.password.placeholder' | translate"
          [type]="hidePassword ? 'password' : 'text'"
          [required]="true"
          [maxLength]="passwordMax"
          [errorMessage]="passwordError"
          [hasSuffix]="true"
        >
          <button
            uiInputSuffix
            type="button"
            class="dialog-admin-upsert__password-toggle"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="'users.upsert.password.toggleVisibility' | translate"
          >
            <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </ui-molecule-input>
        <p class="dialog-admin-upsert__hint">
          {{ 'users.upsert.password.hint' | translate: { min: passwordMin } }}
        </p>
      </div>
    } @else {
      <div class="dialog-admin-upsert__field">
        <ui-molecule-input
          textId="password"
          formControlName="password"
          [label]="'users.upsert.password.editLabel' | translate"
          [placeholder]="'users.upsert.password.editPlaceholder' | translate"
          [type]="hidePassword ? 'password' : 'text'"
          [required]="false"
          [maxLength]="passwordMax"
          [errorMessage]="passwordError"
          [hasSuffix]="true"
        >
          <button
            uiInputSuffix
            type="button"
            class="dialog-admin-upsert__password-toggle"
            (click)="togglePasswordVisibility()"
            [attr.aria-label]="'users.upsert.password.toggleVisibility' | translate"
          >
            <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>
        </ui-molecule-input>
      </div>
    }

    <!-- Context Info -->
    <div class="dialog-admin-upsert__context-info">
      <ui-atom-text type="small" [text]="getContextInfoText()" />
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-admin-upsert__actions">
  <ui-atom-button
    type="button"
    rules="main"
    styling="outlined"
    [withShadow]="false"
    [text]="'common.cancel' | translate"
    matDialogClose
  >
  </ui-atom-button>

  <ui-atom-button
    type="button"
    rules="main"
    styling="filled"
    [withShadow]="true"
    [text]="data.mode === 'edit' ? ('common.save' | translate) : ('common.create' | translate)"
    [disabled]="!form.valid"
    (buttonClick)="submit()"
  >
  </ui-atom-button>
</mat-dialog-actions>
